import { combineReducers } from "redux"; 
import Users from '../../pages/users/userSlice';
import BodySizes from '../../pages/bodySize/bodySizeSlice';
import Category from '../../pages/category/categorySlice';
import BodyShape from '../../pages/bodyshape/BodyShapeSlice';
import FittingSizes from '../../pages/fittingSize/fittingSizeSlice';
import FittingTypes from '../../pages/fittingtype/fittingTypeSlice';
import DataVersions from '../../pages/dataVersion/dataVersionSlice'
import authentication from '../../pages/login/loginSlice';
import ProductTypes from '../../pages/ProductType/ProductTypeSlice'
import UpdateSettings from '../../pages/UpdateSetting/UpdateSettingSlice'
import NutShapes from '../../pages/NutShape/NutShapeSlice'
import NutMaterials from '../../pages/NutMaterial/NutMaterialSlice'
import Nuts from '../../pages/Nut/NutSlice'
import OrificeSizes from '../../pages/orificeSize/orificeSizeSlice'
import ConnectionConversions from '../../pages/connectionConversion/conectionConversionSlice'

const rootReducer = combineReducers({ 
    Users, authentication, BodySizes, Category, BodyShape, FittingSizes, FittingTypes, DataVersions, ProductTypes, UpdateSettings, NutShapes, NutMaterials, Nuts, OrificeSizes, ConnectionConversions
}); 
export type AppState = ReturnType<typeof rootReducer>;  
export default rootReducer;
